export default "__VITE_ASSET__hyeF1NwJ__"